export enum GlobalConfig {
  DEFAUL_TOTAL_ITEMS_PER_PAGE = 25
}
